import { BaseQueryKeys } from '@amzn/gsce-shared-react-lib';

/**
 * Query key constants for tag reference-data queries.
 *
 * Extends the shared lib's BaseQueryKeys pattern — createQuery auto-maps
 * request params into the cache key as [collectionName, params].
 */
export class TagQueryKeys extends BaseQueryKeys {
  /** Matches all tag-list queries. */
  static readonly list = 'tag-list' as const;
}
